module.exports = __webpack_public_path__ + "media/images/img_support01-63f18058746b6945246d0354dd22c488.jpg";